import * as React from "react";

import Loading from "../../common/fragments/Loading";
import { Query } from "../../core/api/typedQuery";
import { FragmentProvider } from "../../core/components/FragmentProvider";
import { IPanelProps, Panel } from "../../core/decorators/Panel";
import Product from "./entities/Product";
import ProductDetailsConfig from "./ProductDetailsConfig";
import * as fragments from "./productFragments";
import { IProductFragmentProps } from "./productFragments";

interface IProductParams {
	id: number;
}

const ProductQuery = Query.queryOne<Product, IProductParams>(Product);
export const Provider = FragmentProvider.forFragments("productDetails", fragments);

@Panel({id: "productDetails", configClass: ProductDetailsConfig, pageParams: true})
class ProductDetailsPanel extends React.Component<IPanelProps<ProductDetailsConfig>> {

	public render() {
		const { config, pageParams } = this.props;

		if(!pageParams.productId) {
			return "Product not found";
		}

		return (
			<ProductQuery params={{id: pageParams.productId}}>
				{
					({data, loading}) => {

						if(loading) {
							return <Loading />;
						}

						if(!data) {
							return "Product not found";
						}

						const props: IProductFragmentProps = {
							product: data
						};

						return <Provider fragments={config.fragmetns} fragmentProps={props} />;
					}
				}
			</ProductQuery>
		);
	}
}



// WEBPACK FOOTER //
// ./src/panels/productDetails/ProductDetails.panel.tsx